import React from "react";
import svgUrl from "/opt/actions-runner/_work/v3-swap/v3-swap/src/assets/images/dropdown.svg?url";
const SvgDropdown = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 12,
  height: 7,
  viewBox: "0 0 12 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M0.97168 1L6.20532 6L11.439 1",
  stroke: "#AEAEAE"
}));
export {SvgDropdown as ReactComponent};
export default svgUrl;
